import {omneticApi} from '@dms/api/base';

import {GetEffectiveValueWithoutReferenceApiResponse} from '../generalSettings/types';
import {
  DEFAULT_PROMOTIONAL_PHOTO_FINANCING_DISPLAY,
  PROMOTIONAL_PHOTO_FINANCING_DISPLAY_SETTING_ID,
  PromotionalPhotoFinancingDisplay,
  PromotionalPhotoFinancingDisplaySchema,
} from './types';

// Typed wrapper over the generic tenant setting endpoints for one settingId; shares the
// 'GeneralSettingsTenant' tag so it stays in sync with the generic hooks. Reads go through
// effective-value, which returns the value object itself (the `/tenant` GET returns an array of
// tenant records). The BE default is `{mode: 'ALL', order: []}`. `order` is returned as saved,
// because the form shows the products missing from a PREFERRED order as unselected.
export const promotionalPhotoFinancingDisplayApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getPromotionalPhotoFinancingDisplay: build.query<PromotionalPhotoFinancingDisplay, void>({
      query: () => ({
        url: `/dms/v1/settings/${PROMOTIONAL_PHOTO_FINANCING_DISPLAY_SETTING_ID}/effective-value/myself/without-reference`,
      }),
      transformResponse: (response: GetEffectiveValueWithoutReferenceApiResponse) => {
        const parsed = PromotionalPhotoFinancingDisplaySchema.safeParse(response);
        return parsed.success ? parsed.data : DEFAULT_PROMOTIONAL_PHOTO_FINANCING_DISPLAY;
      },
      providesTags: [
        {type: 'GeneralSettingsTenant', id: PROMOTIONAL_PHOTO_FINANCING_DISPLAY_SETTING_ID},
      ],
    }),
    setPromotionalPhotoFinancingDisplay: build.mutation<void, PromotionalPhotoFinancingDisplay>({
      query: (value) => ({
        url: `/dms/v1/settings/${PROMOTIONAL_PHOTO_FINANCING_DISPLAY_SETTING_ID}/tenant`,
        method: 'POST',
        body: {value, force: false},
      }),
      invalidatesTags: [
        {type: 'GeneralSettingsTenant', id: PROMOTIONAL_PHOTO_FINANCING_DISPLAY_SETTING_ID},
      ],
    }),
  }),
});

export const {
  useGetPromotionalPhotoFinancingDisplayQuery,
  useSetPromotionalPhotoFinancingDisplayMutation,
} = promotionalPhotoFinancingDisplayApi;
